module.exports = __webpack_public_path__ + "officialStatic/img/solutionActive1.a570cc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/solutionActive1.png
// module id = BAxp
// module chunks = 0